import axios from "axios";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../../config/config";
import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { checkUserPermission } from "../../../../common/UserPermission";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from "../../../../common/Toast";
import { DELETE_MESSAGE } from "../../../../common/Constant";

const CountInventory = (props) => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);

  console.log(data, "hhhh");
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [status, setStatus] = useState("close");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(10);
  const locationId = localStorage.getItem("Location");

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [showicon, setshowicon] = useState(true);
  const [commnet, setcomment] = useState("");

  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const handlePerRowsChange = async (page, newPerPage, pstatus) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, pstatus);
  };

  const handlePageChange = (page, pstatus) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, pstatus);
  };

  const handleListData = (
    pagenumber,
    pagesize,
    pstatus,
    filtercolumnsearchtext,
    currentorder,
    ordercolumn,
    filtertext
  ) => {
    // console.log(pagenumber, pagesize, pstatus);
    setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    axios
      .get(
        `${
          config.itemsBaseUrl
        }/items/countitemslist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&status=${pstatus}&locationid=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);
        // console.log(
        //   "Total Records ==> ",
        //   res.data.ResponseData[0]?.TotalRecord
        // );
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        // console.log("err ==> ", err);
      });
  };

  const handleSubmit = () => {
    // Count Inventory Upsert
    navigate(`/new-inventory-count`);
    // setLoading(true);
    // axios
    //   .post(
    //     `${config.itemsBaseUrl}/items/countinventoryupsert`,
    //     {
    //       id: 0,
    //       loginuserid: Id,
    //       locationid: locationId,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
    //       toastSuccess(SUCCESS_MESSAGE);
    //       // console.log(res.data.ResponseID);
    //       navigate(`/new-inventory-count/${res.data.ResponseID}`);
    //     } else if (
    //       res.data.ResponseCode === "ERROR" &&
    //       res.data.ResponseID === -1
    //     ) {
    //       toastError("Name" + ALREADY_EXIST);
    //     } else {
    //       toastError(ERROR_MESSAGE);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     setLoading(false);
    //     // console.log("error: ", error);
    //   });
  };

  const handleStatus = (pStatus) => {
    // console.log("Status ==> ", pStatus);
    if (pStatus == "open") {
      setStatus("close");
    } else {
      setStatus("open");
    }
    handleListData(1, 10, pStatus);
  };

  const handleDeletePopup = (pID) => {
    // console.log("pID ==> ", pID);

    const deleteRequestParam = {
      id: pID,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  useEffect(() => {
    handleStatus(status);
  }, [columnFilters, globalFilter, pagination, sorting]);

  // Table Data
  // const columns = [
  //   // {
  //   //   name: "Id",
  //   //   selector: (row) => row.Id,
  //   //   width: "5%",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Count Date",
  //     selector: (row) => moment(row.Countdate).format("DD MMMM YYYY"),
  //     // width: "10%",
  //     sortable: false,
  //   },
  //   {
  //     name: "Items Counted",
  //     selector: (row) => row.ItemsCounted,
  //     sortable: false,
  //     // width: "12%",
  //   },
  //   {
  //     name: "Employee",
  //     selector: (row) => row.Employee,
  //     sortable: false,
  //     width: "10%",
  //   },

  //   {
  //     name: "Status",
  //     // width: "10%",
  //     selector: "",
  //     sortable: false,
  //     cell: (row) => (
  //       <>
  //         <select className="form-control form-control-sm" value={row.Status == 3 ? 1 : 2}>
  //           <option value="" disabled>
  //             Select Status
  //           </option>
  //           <option value="1">Open</option>
  //           <option value="2">Close</option>
  //         </select>
  //       </>
  //     ),
  //   },
  //   // {
  //   //   name: "Comments",
  //   //   selector: "",
  //   //   sortable: false,
  //   //   cell: (row) => (
  //   //     <>
  //   //       <input className="form-control form-control-sm" defaultValue={row.Comment} />
  //   //     </>
  //   //   ),
  //   // },
  //   {
  //     name: "Delete Count",
  //     selector: "",
  //     cell: (row) => (
  //       row.Status != 1 && (
  //         <>
  //           <Link
  //             className="confirm-text btn btn-sm btn-danger btn-custom-padding"
  //             to="#"
  //             title="Delete"
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup(row.Id)}
  //           >
  //             Delete Count
  //           </Link>
  //           {/* <button className="btn btn-danger">Delete Count</button> */}
  //         </>
  //       )
  //     ),
  //     sortable: false,
  //   },
  //   {
  //     name: "Count",
  //     selector: "",
  //     cell: (row) => (
  //       <>
  //         <Link
  //           className="btn btn-sm btn-success btn-custom-padding"
  //           to={`/new-inventory-count/${row.Id}`}
  //         >
  //           {status == "open" ? `View Count` : `Continue Count`}
  //         </Link>
  //       </>
  //     ),
  //     sortable: false,
  //   },
  // ];
  const handlecomment = (e, value) => {
    console.log(e.target.value, value, "778787878");
    setcomment(e.target.value);
  };

  const finalcall = (value) => {
    let reqobj = {
      ID: value,
      Comment: commnet,
    };

    axios
      .post(`${config.itemsBaseUrl}/items/invcomment`, reqobj, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res);
        setshowicon(true);
        toastSuccess("Comment updated");
        setTimeout(() => {
          window.location.reload();
        }, 700);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = useMemo(() => [
    {
      header: "Delete Count",
      Cell: ({ row }) =>
        row.original.Status != 1 && (
          <>
            {checkUserPermission("delete-item-inventory-continue-count") ? (
              <Link
                className="confirm-text btn btn-sm btn-secondary"
                to="#"
                title="Delete"
                data-bs-toggle="modal"
                data-bs-target="#DeleteConfirmationModal"
                onClick={() => handleDeletePopup(row.original.Id)}
              >
                Delete Count
              </Link>
            ) : (
              " "
            )}
            {/* <button className="btn btn-danger">Delete Count</button> */}
          </>
        ),
    },
    {
      header: "Count",
      Cell: ({ row }) => (
        <>
          {checkUserPermission("/new-inventory-count/:id") ? (
            <Link
              className="btn btn-sm btn-primary"
              to={`/new-inventory-count/${row.original.Id}`}
            >
              {status == "open" ? `View Count` : `Continue Count`}
            </Link>
          ) : (
            " "
          )}
        </>
      ),
    },
    {
      header: "Count Date",
      accessorKey: "Countdate",
      Cell: ({ row }) =>
        moment(row.original.Countdate).format("MM-DD-YYYY hh:mm:ss a"),
    },
    {
      header: "Items Counted",
      accessorKey: "ItemsCounted",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "Status",
      Cell: ({ row }) => (
        <>
          <select
            className="form-control form-control-sm"
            value={
              row.original.Status == 3 ? 1 : row.original.Status == 2 ? 2 : 3
            }
          >
            <option value="" disabled>
              Select Status
            </option>
            <option value="1">Open</option>
            <option value="2">Close</option>
            <option value="3">Receipt</option>
          </select>
        </>
      ),
    },
    {
      header: "comment",
      Cell: ({ row }) => (
        <>
          {showicon ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {data.find((item) => item.Id == row.original.Id)?.Comment}
              <i
                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                onClick={() => setshowicon(false)}
                style={{
                  cursor: "pointer",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              ></i>
            </div>
          ) : (
            <>
              <input
                className="form-control"
                onChange={(e) => handlecomment(e, row.original.Id)}
                type="text"
              />
              <span
                style={{ cursor: "pointer" }}
                onClick={() => finalcall(row.original.Id)}
              >
                <i
                  className="fa fa-check fs-3 ml-2 align-content-center"
                  aria-hidden="true"
                ></i>
              </span>
            </>
          )}
        </>
      ),
    },
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Count Inventory</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item active">Count Inventory</li>
              </ul>
            </div>
          </div>
          <div className="col-md-12">
            <div className="d-flex flex-row-reverse">
              <div className="p-2">
                {checkUserPermission("show-closed-counts") ? (
                  <button
                    className={
                      status == "open"
                        ? `btn btn-sm btn-secondary`
                        : `btn btn-sm btn-secondary`
                    }
                    // to="/show-closed-counts"
                    onClick={() => handleStatus(status)}
                  >
                    {status !== "open"
                      ? `Show Open Counts`
                      : `Show Closed Counts`}
                  </button>
                ) : (
                  " "
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark ml-3"
                  style={{ borderRadius: "5px", padding: "8px" }}
                  onClick={() => navigate("/items")}
                >
                  Back
                </button>
              </div>
              <div className="p-2">
                {checkUserPermission("/new-inventory-count") ? (
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleSubmit}
                  >
                    New Inventory Count
                  </button>
                ) : (
                  " "
                )}
              </div>
            </div>
          </div>

          {/* Card for listing count inventory */}
          {/* <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Count Inventory"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangesPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  
                  dense
                />
              </div>
            </div>
          </div> */}
          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            positionGlobalFilter="left"
            // enableRowActions
            // renderRowActionMenuItems={({ row }) =>
            //   [
            //     <MenuItem key="edit" onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}>
            //       Edit
            //     </MenuItem>,
            //     <MenuItem
            //       className="confirm-text"
            //       to="#"
            //       // key="delete"
            //       title="Delete"
            //       data-bs-toggle="modal"
            //       data-bs-target="#DeleteConfirmationModal"
            //       onClick={() => handleDeletePopup(row.original.ID, "", "")}
            //     >
            //       Delete
            //     </MenuItem>,
            //     (row.original.Attachements) ? (
            //       <a
            //         className="dropdown-item confirm-text"
            //         href={row.original.Attachements}
            //         target="_blank"
            //         title="Attachment"
            //       >
            //         <MenuItem
            //           title="Attachment"
            //         >
            //           Attachments
            //         </MenuItem>
            //       </a>
            //     ) : ("")
            //   ]
            // }

            enableGrouping
            enableStickyHeader
            enableStickyFooter
            // enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "comfortable",
              showGlobalFilter: true,
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

            //For color of each alternative row(Zebra-column)
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            // For providing color to header of table
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              // isError
              // ? {
              //   color: "error",
              //   children: "Error loading data",
              // }
              // : undefined
              {
                isError: () => ({
                  color: "error",
                  children: "Error loading data",
                }),
                sx: (theme) => ({
                  background: "var(--datatable-row-background-color)", //'#e9e9e9',
                  lineHeight: "16px",
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                }),
              }
            }
            muiSelectCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            muiSelectAllCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              columnFilters,
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/countitemsdeleted`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default CountInventory;
